import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import {
  Text,
  Button,
  Card,
  Flex,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  useDisclosure,
  Divider,
} from '@chakra-ui/react';
import { TState } from '../../redux/store';
import {
  fetchFile,
  fetchFiles,
  fetchPdfList,
  generatePdf,
  signResend,
  signStart,
} from '../../api/tabsApi';
import { momentTimezone } from '../utils/dateUtils';
import RSelect from '../form/RSelect';
import { allIcons, NormalIcon } from '../utils/Icon';
import RStepper from '../common/RStepper';
import { getComponentByFileType } from '../files/FileViewer';

const TRADS: any = {
  'signature_request.activated': 'Activée',
  'signer.notified': 'Notifié',
  'signer.link_opened': 'Lien ouvert',
  'signer.done': 'Signé',
  'signature_request.done': 'Terminé',
  'signer.declined': 'Décliné',
  'signer.notification_delivery_failed': 'Erreur mail',
  'signature_request.reminder_executed': 'Rappel',
  'signature_request.canceled': 'Annulé',
};

const PDFGenerationTab = () => {
  const rowData = useSelector((state: TState) => state.rowData);
  const currentTab = useSelector((state: TState) => state.currentTab);

  const { isOpen, onOpen, onClose } = useDisclosure();
  const [currFile, setCurrFile] = useState<any>();
  const [files, setFiles] = useState([]);
  const [generatedFiles, setGeneratedFiles] = useState<
    {
      _id: string;
      user: string;
      userId: string;
      rowId: string;
      date: string;
      filename: string;
      isGenerated: boolean;
      type: string;
      steps: any[];
    }[]
  >([]);
  const [selected, setSelected] = useState<any[]>([]);

  useEffect(() => {
    const getList = async () => {
      try {
        const resp = await fetchPdfList();
        setFiles(resp.data);

        const fileResp = await fetchFiles(rowData._id, true);
        setGeneratedFiles(fileResp.data);
      } catch (error) {
        console.error('error', error);
      }
    };

    rowData._id && getList();
  }, [rowData._id]);

  const handleGenerate = async () => {
    await generatePdf({
      rowId: rowData._id,
      filesname: selected.map((s) => s.value),
    });

    const fileResp = await fetchFiles(rowData._id, true);
    setGeneratedFiles(fileResp.data);
  };

  const handleOpenFile = async (id: string) => {
    const resp = await fetchFile(id, true);
    setCurrFile(resp);
    onOpen();
  };

  // const handleDelete = async (id: string) => {
  //   const resp = await fetchFile(id);
  //   setCurrFile(resp);
  //   onOpen();
  // };

  const handleSign = async (id: string) => {
    currentTab?._id &&
      (await signStart(id, { rowId: rowData._id, tabId: currentTab?._id }));
  };

  const handleResend = async (signId: string) => {
    await signResend(signId);
  };

  return (
    <>
      <Flex gap={2} alignItems='center'>
        <RSelect
          isMulti
          options={files.map((f: any) => ({ label: f.name, value: f.name }))}
          onChange={setSelected}
        />
        <Button onClick={handleGenerate}>Générer</Button>
      </Flex>
      {generatedFiles.map((generatedFile) => (
        <Card p={2} my={2} bgColor='#f9fafb' gap={5}>
          <Flex gap={3} alignItems='center'>
            <Text flexGrow={1}>{generatedFile.filename}</Text>
            <NormalIcon
              as={allIcons.HiEye}
              onClick={() => handleOpenFile(generatedFile._id)}
            />
            {/* <NormalIcon
              as={allIcons.HiTrash}
              onClick={() => handleDelete(generatedFile._id)}
            /> */}
            <Button onClick={() => handleSign(generatedFile._id)}>
              Signer
            </Button>
          </Flex>
          {!!generatedFile.steps?.length && (
            <Flex gap={3} flexDirection='column' px={3}>
              {generatedFile.steps.map(
                (s, idx) =>
                  !!s.events?.length && (
                    <>
                      {!!idx && <Divider />}
                      <Flex gap={3}>
                        <RStepper
                          isError={s.events.find(({ name }: any) =>
                            /declined|delivery_failed|canceled/.test(name),
                          )}
                          isSuccess={s.events.find(({ name }: any) =>
                            /signature_request.done/.test(name),
                          )}
                          steps={s.events.map(
                            ({ date, name, signer, reason }: any) => ({
                              title: `${TRADS[name] || name}${
                                /signer\.declined|signer\.done/.test(name)
                                  ? ` par ${signer.first_name} ${signer.last_name}`
                                  : ''
                              }`,
                              description: momentTimezone(`${date}`).format(
                                'DD/MM/YYYY HH:mm',
                              ),
                              reason,
                            }),
                          )}
                        />
                        {!s.events.filter(({ name }: any) =>
                          /declined|failed|canceled|signature_request.done/.test(
                            name,
                          ),
                        ).length &&
                          s.data.signers.map(
                            ({ delivery_mode, signature_link, id }: any) =>
                              s.signed?.includes(id) ? null : delivery_mode ===
                                'none' ? (
                                <Button
                                  onClick={() =>
                                    window.open(signature_link, '_blank')
                                  }
                                >
                                  Signer ma partie
                                </Button>
                              ) : (
                                <Button onClick={() => handleResend(s.signId)}>
                                  Relancer
                                </Button>
                              ),
                          )}
                      </Flex>
                    </>
                  ),
              )}
            </Flex>
          )}
        </Card>
      ))}
      <Modal isOpen={isOpen} onClose={onClose} size='full'>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader></ModalHeader>
          <ModalCloseButton />
          <ModalBody mt={3}>
            {!!currFile && getComponentByFileType(currFile)}
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
};

export default PDFGenerationTab;
